import {
    LOAD_LOCATIONS,
} from "constants/ActionTypes";

const INIT_STATE = {
  locations: [],
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case LOAD_LOCATIONS: {
            return {
                ...state,
                locations: action.payload
            }
        }
        default:
            return state;
    }
}
